module.exports = __webpack_public_path__ + "static/media/lead-bg-2.a85a2e9e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/lead-bg-2.webp
// module id = 1220
// module chunks = 1